import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import Ozitor from 'components/Widgets/Ozitor';
import { Units, Shadow, Colors } from 'Css';
import ColorChooser from '../ColorChooser';
import SizeChooser from '../SizeChooser';
import SliderChooser from '../SliderChooser';
import PositionChooser from '../PositionChooser';
import ImageChooser from '../ImageChooser';
import FormFieldContainer from '../FormFieldContainer';

const css = oxygenCss({
  root: {},
  panel: {
    padding: Units.base
  },
  image: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  colorChooser: {},
  inputWrapper: {
    // width: 5 * (44 + Units.base),
    margin: `0 auto ${Units.base * 2}px`,
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    letterSpacing: '0.3px',
    backgroundColor: '#FBFBFB'
  },
  title: {
    padding: Units.base,
    color: Colors.text.Dark.secondary
  },
  color: {
    border: 'solid 1px #DDD',
    boxSizing: 'border-box',
    display: 'inline-block',
    width: 24,
    height: 24,
    cursor: 'pointer',
    margin: Units.base / 2,
    boxShadow: Shadow[1],
    '&active': {
      border: 'solid 1px #777',
      boxShadow: Shadow[2]
    }
  },
  half: {
    width: 96
  },
  row: {
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    display: 'flex'
  }
});

class StoreBannerModuleEditor extends Component {
  static propTypes = {
    id: PropTypes.string,
    header: PropTypes.string,
    headerPosition: PropTypes.string,
    opacity: PropTypes.number,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    size: PropTypes.number,
    src: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  onChangeHeader = header => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      header
    });
  };

  handleChange = (event, foo, payload) => {
    const { id } = this.props;
    const { headerPosition } = payload;
    StoreOverviewActions.updateModule(id, {
      headerPosition
    });
  };

  chooseColor = color => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      color
    });
  };

  chooseBackgroundColor = backgroundColor => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      backgroundColor
    });
  };

  chooseSize = size => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      size
    });
  };

  chooseOpacity = opacity => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      opacity
    });
  };

  choosePosition = headerPosition => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      headerPosition
    });
  };

  changeImage = src => {
    const { id } = this.props;
    StoreOverviewActions.updateModule(id, {
      src
    });
  };

  render() {
    const {
      size,
      color,
      backgroundColor,
      header,
      opacity,
      headerPosition,
      src
    } = this.props;
    const height = 360 / 1920 * (Units.keyline * 3 * (size || 1));
    const { getIntlMessage } = this.context;
    return (
      <div>
        <div className={css.panel}>
          <div className={css.row}>
            <div className={css.half}>
              <SizeChooser
                onChange={this.chooseSize}
                selected={size}
                title={getIntlMessage('store.size')}
              />
            </div>
            <div className={css.half}>
              <ImageChooser
                onChange={this.changeImage}
                title={getIntlMessage('store.image')}
              />
            </div>
          </div>
          <FormFieldContainer
            title={getIntlMessage('store.bannerApproximation')}
          >
            <div
              className={css.image}
              style={{ height, backgroundImage: `url(${src})` }}
            />
          </FormFieldContainer>
          <ColorChooser
            onChange={this.chooseBackgroundColor}
            title={getIntlMessage('store.backgroundColor')}
            selected={backgroundColor}
          />
          <ColorChooser
            onChange={this.chooseColor}
            title={getIntlMessage('store.Color')}
            selected={color}
          />
          <SliderChooser
            selected={opacity}
            title={getIntlMessage('store.overlayOpacity')}
            step={0.05}
            min={0}
            max={1}
            onChange={this.chooseOpacity}
          />
          <PositionChooser
            backgroundImage={src}
            title={getIntlMessage('store.headerPosition')}
            selected={headerPosition}
            onChange={this.choosePosition}
          />
          <div className={css.inputWrapper}>
            <div className={css.title}>{getIntlMessage('store.header')}</div>
            <Ozitor
              style={{
                content: {
                  backgroundColor: Colors.theme.Light.card,
                  minHeight: Units.keyline * 2,
                  height: Units.keyline * 2,
                  maxHeight: Units.keyline * 2
                },
                root: {
                  minHeight: 'auto'
                }
              }}
              editable
              onChange={this.onChangeHeader}
              defaultContent={header}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default StoreBannerModuleEditor;



// WEBPACK FOOTER //
// ./src/js/components/Store/Editor/Modules/StoreBannerModuleEditor.js